import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * useReviews - Custom Hook to get Branch or Product Reviews
 * @param {String} type - branch | product
 * @param {Strig} code - Branch ID(s) as comma separated string
 * @returns Object of Reviews and Status
 */
export const useReviews = (type, code) => {
	const [reviews, setReviews] = useState({});
	const [status, setStatus] = useState('loading');

	useEffect(() => {
		if (!type && !code) {
			setStatus('failed');
			return;
		}

		if (type === 'product') getProductReviews(code);
		else if (type === 'branch') getBranchReviews(code);
	}, [code, type]);

	async function getProductReviews(code) {
		try {
			const response = await axios.get(`${process.env.GATSBY_PELLA_API}/ratings/product/${code}`);
			if (response?.data) {
				setReviews(response.data);
				setStatus('success');
			}
		} catch (error) {
			setStatus('failed');
		}
	}

	async function getBranchReviews(code) {
		const branches = code?.split(', ');

		if (!branches?.length) {
			setStatus('failed');
			return;
		}

		let divideBy = branches.length;
		let reviewsObj = {};

		for (let i = 0; i < branches.length; i++) {
			const response = await axios.get(`${process.env.GATSBY_PELLA_API}/ratings/pdsn/${branches[i]}00`);

			if (i === 0) {
				reviewsObj = response.data;
			} else {
				if (response.data.Empty) {
					--divideBy;
					continue;
				}

				reviewsObj.OverallSatisfactionRating = reviewsObj.OverallSatisfactionRating + response.data.OverallSatisfactionRating;
				reviewsObj.Reviews = [...reviewsObj.Reviews, ...response.data.Reviews];
				reviewsObj.Total1Star = reviewsObj.Total1Star + response.data.Total1Star;
				reviewsObj.Total2Star = reviewsObj.Total2Star + response.data.Total2Star;
				reviewsObj.Total3Star = reviewsObj.Total3Star + response.data.Total3Star;
				reviewsObj.Total4Star = reviewsObj.Total4Star + response.data.Total4Star;
				reviewsObj.Total5Star = reviewsObj.Total5Star + response.data.Total5Star;
				reviewsObj.TotalReviews = reviewsObj.TotalReviews + response.data.TotalReviews;
			}
		}

		setReviews({
			...reviewsObj,
			OverallSatisfactionRating: reviewsObj?.OverallSatisfactionRating ? (reviewsObj.OverallSatisfactionRating / divideBy).toFixed(2) : 0,
		});

		setStatus('success');
	}

	return { reviews, status };
};
